export const DEFAULT_BACKGROUND_COLOR = "#000000";
